module.exports = __webpack_public_path__ + "static/media/InmLogo.05ad8e9e.png";